
import { Card, CardHeader, CardContent, CardTitle, CardDescription } from "@/components/ui/card";
import { DropZone } from "./profile-picture/DropZone";
import { useProfilePicture } from "./profile-picture/useProfilePicture";

interface ProfilePictureCardProps {
  avatar_url: string;
  full_name: string;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  onAvatarUpdate: (url: string) => void;
}

export function ProfilePictureCard({ 
  avatar_url, 
  full_name, 
  isLoading, 
  setIsLoading,
  onAvatarUpdate 
}: ProfilePictureCardProps) {
  const {
    dragActive,
    handleDrag,
    handleDrop,
    handleImageUpload,
    handleDeleteAvatar
  } = useProfilePicture({
    isLoading,
    setIsLoading,
    onAvatarUpdate
  });

  return (
    <Card className="backdrop-blur-lg bg-white/10 border-white/20 h-full">
      <CardHeader className="p-4">
        <CardTitle className="text-white text-lg">Profile Picture</CardTitle>
        <CardDescription className="text-white/70 text-xs">
          Update your profile picture
        </CardDescription>
      </CardHeader>
      <CardContent className="p-4 pt-0">
        <DropZone 
          avatar_url={avatar_url}
          full_name={full_name}
          isLoading={isLoading}
          dragActive={dragActive}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          onImageUpload={handleImageUpload}
          onDeleteAvatar={handleDeleteAvatar}
        />
      </CardContent>
    </Card>
  );
}
